<script lang="ts">
  import LargeCircleDownSvg from '../../components/SVGs/LargeCircleDownSVG.svelte'
  import SmallCircleDownSvg from '../../components/SVGs/SmallCircleDownSVG.svelte'
  import PlatformHeroGroupOneSvg from '../../components/SVGs/PlatformHeroGroupOneSVG.svelte'
  import PlatformHeroGroupTwoSvg from '../../components/SVGs/PlatformHeroGroupTwoSVG.svelte'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
</script>

<section
  class="relative mx-auto flex flex-col overflow-hidden sm:h-[850px] md:h-[850px] lg:h-[950px] lg-desktop:h-[1000px]"
>
  <div class="mx-auto flex w-full max-w-[1440px] flex-col items-center">
    <div class="relative top-[200px] w-full sm:top-[350px] md:top-[350px] lg:top-[550px] lg-desktop:hidden">
      <LargeCircleDownSvg svgStyles="clipped-image w-screen sm:scale-150 lg:scale-[2]" />

      <SmallCircleDownSvg
        svgStyles="clipped-image absolute top-[200px] w-screen scale-125 sm:scale-[1.7] lg:top-[300px]  md:scale-[2] lg:scale-[2.5] "
      />
    </div>

    <div class="relative top-[200px] hidden lg-desktop:block">
      <PlatformHeroGroupOneSvg />
      <PlatformHeroGroupTwoSvg svgStyles="absolute left-[0px] right-[0px] top-[200px] mx-auto" />
    </div>

    <div class="absolute inset-x-0 top-[20%] flex w-full flex-col sm:top-[150px] lg-desktop:top-[130px]">
      <h1
        class="relative mx-auto h-fit w-[60%] self-center bg-black text-center font-cirka text-[15vw] uppercase leading-[95%] tracking-wide md:text-[120px] lg-desktop:h-fit lg-desktop:w-fit lg-desktop:text-[190px]"
      >
        Fast Secure
      </h1>

      <ButaneImage
        src="Sphere_4.png"
        width={662}
        height={662}
        alt="Sphere tail"
        class="absolute left-1/2 top-[17vw] h-[350px] w-[350px] -translate-x-1/2 scale-[1.1] object-contain sm:h-[500px] sm:w-[500px] md:top-[155px] lg:top-[200px] lg:scale-[1.3] lg-desktop:top-[100px] lg-desktop:h-[662px] lg-desktop:w-[662px] lg-desktop:scale-[1.25]"
        priority
      />

      <h2
        class="relative top-[290px] text-center font-cirka text-[15vw] uppercase tracking-wide sm:top-[410px] md:top-[430px] md:text-[120px] lg:top-[500px] lg-desktop:top-[570px] lg-desktop:text-[190px]"
      >
        Powerful
      </h2>
    </div>
  </div>
</section>

<style>
  :global(.clipped-image) {
    clip-path: ellipse(100% 50% at 50% 0%);
  }
</style>
